module.exports = "img/3.b79ebc.webp";